<template>
  <div class="page-add page">
    <div class="pageTitleBox">
      <div class="boxNameL">新建出库</div>
      <div class="boxNameR">
        <el-button type="warning" @click="$router.back()" size="small"
          >返回</el-button
        >
      </div>
    </div>
    <div style="background-color: #fff; min-height: 500px">
      <el-form class="form">
        <el-row>
          <el-col :span="4">
            <el-form-item label="出库类型:" :label-width="'90px'">
              <el-select
                class="input"
                v-model="outOrderType"
                placeholder="请选择"
                size="small"
              >
                <el-option value="2" label="调拨出库" key="2"></el-option>
                <!-- $store.state.shopId == '5e9412e0b2bfbc089daerr14' -->
                <el-option
                  value="4"
                  label="报废出库"
                  key="4"
                 v-if="$buttonAuthority('cangku2-chuku-baofei')"
                ></el-option>
                <el-option value="3" label="自用出库" key="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="出库日期:" :label-width="'80px'">
              <el-date-picker
                disabled
                format="yyyy-MM-dd"
                value-format="timestamp"
                v-model="params.outDate"
                type="date"
                placeholder="选择日期"
                size="small"
                style="width: 140px"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="outOrderType === '2'">
            <el-form-item label="物品去向:" :label-width="'102px'" required>
              <el-select
                class="input"
                v-model="selectShopId"
                placeholder="请选择"
                size="small"
                style="width: 140px"
              >
                <el-option
                  :label="item.shop_name"
                  :value="item.shop_id"
                  v-for="item in userInfo.shops"
                  :key="item.shop_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1" :offset="7"> </el-col>
        </el-row>
      </el-form>
      <el-button type="warning" size="small" @click="handleSelectGoodsClick(1)">选择商品</el-button>

      <el-table
        :data="shopTable"
        style="width: 100%; margin-top: 10px"
        ref="table"
      >
        <el-table-column label="名称" prop="name"> </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            <span>{{ scope.row.param_sku_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位">
          <template slot-scope="scope">
            <span>{{ scope.row.param_packing_way_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope" >
           <div v-if="scope.row.goodsType==1&&scope.row.param_packing_way_name!=scope.row.param_packing_way_unit">
            <el-input-number v-model="scope.row.numMax" controls-position="right" :min="0" size="small" @change="handleChange1(scope)"></el-input-number>
            <span>{{ scope.row.param_packing_way_name }}</span>
            <el-input-number v-model="scope.row.numMin" controls-position="right" :min="0" size="small" @change="handleChange2(scope)"></el-input-number>
            <span>{{ scope.row.param_packing_way_unit }}</span>
           </div>
           <div v-else> <el-input-number v-model="scope.row.num" controls-position="right" :min="0" size="small" @change="handleChange(scope)"></el-input-number>
            <span>{{ scope.row.param_packing_way_name }}</span></div>
          </template>
        </el-table-column>
        <el-table-column label="条形码" >
          <template slot-scope="scope" >  <el-input
            v-if="scope.row.goodsType==0"
          style="width: 220px"
          placeholder="请输入商品条码"
          v-model.lazy="scope.row.barcode"
          @keyup.enter.native="clickScanningCodeInput"
          size="small"
        ></el-input>
          </template>
        </el-table-column>
       
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              style="color: #ff4000"
              icon="el-icon-delete"
              type="text"
              @click="deleteGoods(scope.row,scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="padding: 20px 0; background-color: #fff">
      <el-form>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注:" :label-width="'60px'">
              <el-input
                type="textarea"
                style="width: 500px"
                rows="4"
                v-model="params.remark"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"> </el-col>
        </el-row>
        <el-row>
          <el-col> </el-col>
          <el-col :span="2" :offset="22">
            <el-button type="warning" @click="submitForm" size="small"
              >提交</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
      <!-- 添加商品弹框 -->
      <div v-if="dialogAddShop_state">
      <dialogAddShop
        @closeOn="dialogAddShop_state = false"
        :addShopState.sync="dialogAddShop_state"
        :selectType.sync="selectType"
        @submit="selectShop"
        :tree.sync="tree"
      ></dialogAddShop>
    </div>
  </div>
</template>
<script>
import del from "../../util/del.js";
import dialogAddShop from "../../components/dialog_addShop";
export default {
  components: {
    dialogAddShop,
  },
  data() {
    return {
      outOrderType: "2",
      selectShopId: "",
      params: {
        id: "",
        outDate: new Date().getTime(),
        remark: "",
      },
      dialogAddShop_state: false, //新增商品弹框状态
      scanningCodeInput: "",
      o: null,
      tableData: [],
      shopTable:[],
      //记录调拨条码
      acceptanceParam: {
        code_list: [],
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  mounted() {
    this.o = new del();
  },
  methods: {
    handleChange1(scope){
      console.log(scope,"max");
      let numMax = 0;
      numMax += scope.row.numMax;
      let num=0;
      num=scope.row.numMax*scope.row.param_in_exchanage
				this.$set(this.shopTable[scope.$index],['numMax'],numMax);
        this.$set(this.shopTable[scope.$index],['num'],num);
    },
    handleChange2(scope){
      console.log(scope,'min');
      let numMin = 0;
      numMin += scope.row.numMin;
      let num=0;
				this.$set(this.shopTable[scope.$index],['numMin'],numMin);
        num=scope.row.numMax*scope.row.param_in_exchanage+scope.row.numMin
      this.$set(this.shopTable[scope.$index],['num'],num);
    },
    handleChange(scope){
      console.log(scope,'min');
      let num = 0;
					num += scope.row.num;
				this.$set(this.shopTable[scope.$index],['num'],num);
    },
    clickScanningCodeInput(scope){
      console.log(scope);
      let barcode = '';
      barcode = scope.row.barcode;
				this.$set(this.shopTable[scope.$index],['barcode'],barcode);
      },       //已选中商品
    selectShop(val) {
      console.log("已选中商品11111", val);
      let shopObj = {
        param_type_id:val.goodsType+ "",
      };
      console.log("已选中商品", shopObj);
      //添加商品
        if (val.goodsType == 0) {
          //商品类目
          shopObj.param_type_name = "商品"; //类型名字
          shopObj.id = val.goodsItem.goodsId; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.barcode='';
          shopObj.num = 1; //商品名字
          shopObj.goodsType = 0; //商品名字
          shopObj.param_sku_id = val.skuItem._id; //规格id
          shopObj.param_sku_name = val.skuItem.skus_name; //规格
          shopObj.param_packing_way_id = val.wayItem.packing_way_id; //包装方式id
          shopObj.param_packing_way_name = val.wayItem.packing_way_name; //包装方式名称
        } else if (val.goodsType == 1) {
          //医疗
          shopObj.param_type_name = "医疗"; //类型名字
          shopObj.id = val.goodsItem.medical_id; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.num = 1; //商品名字
          shopObj.numMax = 0; //商品名字
          shopObj.numMin = 0; //商品名字
          shopObj.goodsType = 1; //商品名字
          shopObj.param_sku_id = ""; //规格id
          shopObj.param_sku_name =val.skuItem.sku_value; //规格
          shopObj.param_packing_way_id = val.skuItem.unit; //包装方式最大单位
          shopObj.param_packing_way_unit = val.skuItem.unit; //包装方式最小单位
          shopObj.param_packing_way_name = val.skuItem.in_unit; //包装方式名称
          shopObj.param_in_exchanage = val.skuItem.in_exchanage; //出库单位
          shopObj.barcode='';
        }else if (val.goodsType == 7) {
          //医疗
          shopObj.param_type_name = "耗材"; //类型名字
          shopObj.id = val.goodsItem.consumablematerial_id; //商品id
          shopObj.name = val.goodsItem.title; //商品名字
          shopObj.num = 1; //商品名字
          shopObj.goodsType = 7; //商品名字
          shopObj.param_sku_id = ""; //规格id
          shopObj.param_sku_name = ""; //规格
          shopObj.barcode='';
          shopObj.param_packing_way_id =val.wayItem; //包装方式id
          shopObj.param_packing_way_name = val.wayItem; //包装方式名称
        }
        shopObj.param_custom_code = ""; //芯片编号
        for (let i = 0; i < this.shopTable.length; i++) {
          console.log(this.shopTable[i],'"iiiiii"');
          if (shopObj.param_type_id == 0) {
            if (
              shopObj.id == this.shopTable[i].id &&
              shopObj.param_sku_id == this.shopTable[i].param_sku_id &&
              shopObj.param_packing_way_id ==
                this.shopTable[i].param_packing_way_id
            ) {
              this.$message({
                type: "error",
                message: "已重复添加",
              });
              return;
            }
          } else {
            if (
              shopObj.id == this.shopTable[i].id &&
              shopObj.param_sku_id == this.shopTable[i].param_sku_id
            ) {
              this.$message({
                type: "error",
                message: "已重复添加",
              });
              return;
            }
          }
        }
        this.shopTable.push(shopObj);
        console.log("商品列表", this.shopTable);
        this.$message({
          type: "success",
          message: "已添加",
        });
      
    },
       //选择商品
       handleSelectGoodsClick(type) {
      if (type == 1) {
        console.log("添加产品");
        this.dialogAddShop_state = true;
        this.selectType = type;
        this.tree = [
          {
            //显示所需要类目
            id: "602f1e89c904d9db7ccf3c03", //商品
          },
          {
            id: "602f1e88c904d9db7ccf3bec", //医疗
          },{
            id:"6049cf035a0dfcc381f9311a" //耗材
          },
         
        ];
      }
    },
  
    // 100000247621
    // 提交
    submitForm() {
      if (this.outOrderType === "2") {
        if (this.selectShopId.length === 0) {
          this.$message({
            message: "请选择物品去向",
            type: "error",
          });
          return;
        }
      }
      if (this.shopTable.length === 0) {
        this.$message({
          message: "请录入要出库的商品",
          type: "error",
        });
        return;
      }
      let outOrderItems = [];
      for (let i = 0; i < this.shopTable.length; i++) {

          let goods = this.shopTable[i];
     
            console.log(goods,'goods');
            let item = {
              productId: goods.id,
              skuId: goods.param_sku_id,
              unitId: goods.param_packing_way_id,
              barCode:goods.barcode,
              count: goods.num,
              productType: goods.goodsType,
            };
            outOrderItems.push(item);
          
        
      }
      let params = {
       
        outUserId: this.userInfo.uid,
        outUserName: this.userInfo.uName,
        outOrderFile: "",
        checkOrderFile: "",
        transfersOrderFile: "",
        remark: this.params.remark,
        items: outOrderItems,
      };
      console.log(params, "params");

      this.$confirm(
       
          "提交后将自动申请通过，请谨慎操作。确定提交?",
        "提示",
        {
          confirmButtonText: "确定提交",
          cancelButtonText: "我再核对一下",
          type: "warning",
        }
      ).then(() => {
        let loading = this.$loading();
        let http;
        if (this.outOrderType === "2") {
          if (this.selectShopId.length === 0) {
            this.$message({
              message: "请选择物品去向",
              type: "error",
            });
            return;
          }
          params.transferOutShopId = this.curShopId;
          params.transferInShopId = this.selectShopId;
          http = this.$http.post(
            process.env.VUE_APP_Url66 +
              "api/out/shop/transferout",
            params
          );
        }  else if (this.outOrderType === "4") {
          params.currentShopId = this.curShopId;
          http = this.$http.post(
            process.env.VUE_APP_Url66 + "api/out/shop/scrap",
            params
          );
        }else if (this.outOrderType === "3") {
          params.currentShopId = this.curShopId;
          http = this.$http.post(
            process.env.VUE_APP_Url66 + "api/out/shop/SelfUse",
            params
          );
        }
        http.then((res) => {
          loading.close();
          if (res.code == 0) {
            if (res.code == 0) {
              this.$router.back();
            }
          }
        });
      });
    },
    // 删除添加的商品
    deleteGoods(index,index2) {
      this.$confirm("确认删除该商品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.shopTable.splice(index2, 1);
      });
    },

  },
};
</script>
<style lang="scss">
.page-add {
  .pageTitleBox {
  }
  .form {
    padding: 16px 0 0 0;
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        color: $fontColor;
      }
    }
  }
  .wrapper {
    .tit {
      font-size: 16px;
      margin-bottom: 28px;
      background-color: #f5f5f5;
      height: 40px;
      line-height: 40px;
      border-radius: 3px;

      .name {
        margin-left: 20px;
      }

      .day {
        color: #666;
      }
    }
  }
}

.row-expand-cove .el-table__expand-icon {
  display: none;
}

.el-table .sort-caret.descending {
  border-top-color: #000;
}

.el-table .sort-caret.ascending {
  border-bottom-color: #000;
}
.outinput {
  border: none;
  border-bottom: 1px solid #333;
  width: 35px;
  height: 27px;
  margin-right: 10px;
  .el-input__inner {
    text-align: center;
    padding: 2px;
    background: none;
    border: 0;
    height: 25px;
    line-height: 25px;
  }
}
</style>
